import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class TextbookTaskService {
  url=ConfigService.toApiUrl("textbook-tasks/");

  constructor(private http:HttpClient) { }

    getAll(){
    return this.http.get<any[]>(`${this.url}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("textbook-tasks-by-state")}/${state}`,ConfigService.addAction('list'));
  }

  getByTextbook(tbId:any,studentId?:any){
    if (studentId==undefined) {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("textbook-tasks-by-textbook")}/${tbId}`,ConfigService.addAction('list'));

    } else {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("textbook-tasks-by-textbook")}/${tbId}?studentId=${studentId}`,ConfigService.addAction('list'));

    }
  }


  getForStudent(studentId?:any){
    if (studentId==undefined) {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("textbook-tasks-student")}`,ConfigService.addAction('list'));

    }else{
      return this.http.get<any[]>(`${ConfigService.toApiUrl("textbook-tasks-student")}?studentId=${studentId}`,ConfigService.addAction('list'));

    }
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    ressource['_method']='patch';
    //ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("textbook-tasks-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
}
